module.exports = __webpack_public_path__ + "img/research_item_3.470adde7.png";